interface Props {
  theme: 'light' | 'dark'
  onToggle: () => void
}

export function ThemeToggle({ theme, onToggle }: Props) {
  return (
    <button
      onClick={onToggle}
      aria-label="Toggle dark mode"
      className="grid h-10 w-10 place-items-center rounded-full border border-brand-200 dark:border-brand-700 text-lg transition hover:bg-brand-100/60 dark:hover:bg-brand-800/60"
    >
      {theme === 'dark' ? '☀️' : '🌙'}
    </button>
  )
}
